import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { SharedModule } from '../../shared/shared.module';
import { CustomerDialogComponent } from './components/customer-dialog/customer-dialog.component';
import { CustomerMessageDialogComponent } from './components/customer-message-details-dialog/customer-message-details-dialog.component';
import { IssueListResultComponent } from './components/issue-list-results/issue-list-results.component';
import { IssuesEditModalComponent } from './components/issues-edit-modal/issues-edit-modal.component';
import { KeywordDialogComponent } from './components/keyword-dialog/keyword-dialog.component';
import { IssueListComponent } from './components/list/issue-list.component';
import { SelfHelpComponent } from './components/self-help-dialog/self-help.component';
import { SiteMessagesDialogComponent } from './components/site-messages-dialog/site-messages-dialog.component';
import { SiteSpecificDialogComponent } from './components/site-specific-message-details/site-specific-message-details-dialog.component';
import { IssueRoutingModule } from './issue-routing.module';
import { IssueService } from './service/issue.service';
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    IssueRoutingModule,
    GridModule,
    ReactiveFormsModule,
    FormsModule,
    TooltipModule
  ],
  declarations: [
    IssueListComponent,
    IssueListResultComponent,
    KeywordDialogComponent,
    CustomerDialogComponent,
    IssuesEditModalComponent,
    CustomerMessageDialogComponent,
    SelfHelpComponent,
    SiteMessagesDialogComponent,
    SiteSpecificDialogComponent
  ],

  exports: [],
  providers: [IssueService],
  entryComponents: [
    KeywordDialogComponent,
    IssuesEditModalComponent,
    CustomerDialogComponent,
    CustomerMessageDialogComponent,
    SelfHelpComponent,
    SiteMessagesDialogComponent,
    SiteSpecificDialogComponent,
    SelfHelpComponent
  ]
})
export class IssueModule {}
